import { QuizStep, QuizStepQuestionIq } from "@web-solutions/base-app/screens/quiz/interfaces"

import { QUESTIONS, } from './data';

export const STEPS: { [key: string]: QuizStepQuestionIq | QuizStep } = {};
QUESTIONS.forEach((currentObject, index) => STEPS[`QUESTION_${index}`] = { ...currentObject, id: index });
